"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Search, PenTool, Activity, HardHat, ShieldCheck, ChevronRight, FileText, CircleCheck, Zap } from "lucide-react";
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
const steps = [{
  id: "01",
  title: "Selezione",
  description: "Scegli il modello ideale per le tue esigenze e il tuo stile di guida.",
  icon: Search
}, {
  id: "02",
  title: "Booking",
  description: "Personalizza il tuo setup e prenota online in pochi istanti.",
  icon: PenTool
}, {
  id: "03",
  title: "Performance",
  description: "Testiamo ogni componente e ricarichiamo il sistema per te.",
  icon: Activity
}, {
  id: "04",
  title: "Ritiro",
  description: "Briefing tecnico e regolazione personalizzata delle sospensioni.",
  icon: HardHat
}, {
  id: "05",
  title: "Check-out",
  description: "Ispezione finale e analisi dei dati della tua sessione di guida.",
  icon: ShieldCheck
}];
const subSteps = [{
  stepId: "01",
  text: "Scelta tra modelli MTB, Urban o Road"
}, {
  stepId: "01",
  text: "Verifica taglia e geometria del telaio"
}, {
  stepId: "01",
  text: "Confronto motori Bosch e Shimano"
}, {
  stepId: "02",
  text: "Selezione date e orari di noleggio"
}, {
  stepId: "02",
  text: "Aggiunta accessori tecnici (GPS, Pedali)"
}, {
  stepId: "02",
  text: "Assicurazione Kasko premium inclusa"
}, {
  stepId: "03",
  text: "Diagnostica elettronica della batteria"
}, {
  stepId: "03",
  text: "Lubrificazione e taratura del cambio"
}, {
  stepId: "03",
  text: "Controllo pressione e integrità pneumatici"
}, {
  stepId: "04",
  text: "Configurazione sospensioni su peso rider"
}, {
  stepId: "04",
  text: "Spiegazione modalità di assistenza"
}, {
  stepId: "04",
  text: "Consegna kit di riparazione rapida"
}, {
  stepId: "05",
  text: "Analisi telemetria e chilometri percorsi"
}, {
  stepId: "05",
  text: "Verifica integrità strutturale post-uscita"
}, {
  stepId: "05",
  text: "Sanificazione ecologica del veicolo"
}];
const deliverables = [{
  stepId: "01",
  text: "Guida alla Scelta E-Bike"
}, {
  stepId: "01",
  text: "Scheda Tecnica del Modello"
}, {
  stepId: "02",
  text: "Voucher Prenotazione Digitale"
}, {
  stepId: "02",
  text: "Polizza Copertura Danni"
}, {
  stepId: "03",
  text: "Report Stato Elettronica"
}, {
  stepId: "03",
  text: "Certificato di Igiene e Sanità"
}, {
  stepId: "04",
  text: "Mappe GPX Personalizzate"
}, {
  stepId: "04",
  text: "Tutorial Rapido di Bordo"
}, {
  stepId: "05",
  text: "Statistiche Sessione di Guida"
}, {
  stepId: "05",
  text: "Bonus Fedeltà Prossimo Tour"
}];
export default function ConsultingWorkflow() {
  return <section data-section-id="224948" id="come-funziona-il-noleggio" className="dark relative w-full bg-background text-foreground py-24 md:py-32 overflow-hidden border-y border-border/50">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/cad_wireframe_bg.png)] bg-cover bg-center mix-blend-luminosity" />
      <div className="absolute inset-0 z-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:32px_32px]" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-20 max-w-4xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 border border-primary/20 bg-primary/5 text-primary text-[10px] font-mono tracking-[0.2em] uppercase rounded-md">
            <Zap className="w-3 h-3 fill-primary animate-pulse" />
            Performance Protocol v4.0
          </div>
          <h2 className="text-4xl md:text-7xl font-bold font-sans text-foreground mb-6 tracking-tighter uppercase italic">
            Workflow <span className="text-primary">Operativo</span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-2xl leading-relaxed">
            Un ecosistema ingegnerizzato per l&apos;eccellenza. Ogni fase del noleggio è ottimizzata per garantire sicurezza, performance e un&apos;esperienza di guida superiore.
          </p>
        </div>

        {}
        <div className="relative w-full overflow-x-auto pb-12 -mx-4 px-4 md:mx-0 md:px-0 hide-scrollbar">
          <div className="min-w-[1000px] md:min-w-full relative pt-16 pb-8">
            
            {}
            <div className="absolute top-[5.5rem] left-12 right-12 h-[1px] bg-border/30">
              <div className="absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/40 to-primary/0" />
            </div>

            <div className="flex justify-between relative z-10">
              {steps.map((step, i) => {
              const Icon = step.icon;
              const stepSubSteps = subSteps.filter(s => s.stepId === step.id);
              const stepDeliverables = deliverables.filter(d => d.stepId === step.id);
              return <SafeHydrate><Drawer key={step.id}>
                    <DrawerTrigger asChild>
                      <div data-index={i} className="flex flex-col items-center group cursor-pointer w-56 shrink-0">
                        {}
                        <div className="relative w-20 h-20 mb-8 transition-all duration-500 group-hover:-translate-y-2">
                          <div className="absolute inset-0 bg-card border border-border/50 rotate-45 transition-all duration-500 group-hover:border-primary group-hover:shadow-[0_0_30px_rgba(180,255,0,0.15)]" />
                          <div className="absolute inset-0 flex items-center justify-center text-muted-foreground group-hover:text-primary transition-colors duration-500">
                            <Icon className="w-8 h-8" />
                          </div>
                          {}
                          <div className="absolute -top-1 -left-1 w-3 h-3 border-t-2 border-l-2 border-primary opacity-0 group-hover:opacity-100 transition-all duration-500" />
                          <div className="absolute -bottom-1 -right-1 w-3 h-3 border-b-2 border-r-2 border-primary opacity-0 group-hover:opacity-100 transition-all duration-500" />
                        </div>
                        
                        {}
                        <div className="text-center">
                          <span className="block text-[10px] font-mono text-primary mb-3 tracking-widest opacity-60 group-hover:opacity-100 transition-opacity">
                            SYSTEM_PHASE_{step.id}
                          </span>
                          <h3 className="text-xl font-bold font-sans text-foreground uppercase tracking-tight group-hover:text-primary transition-colors">
                            {step.title}
                          </h3>
                        </div>
                      </div>
                    </DrawerTrigger>
                    
                    <DrawerContent className="border-t border-border/50 bg-background/98 backdrop-blur-2xl rounded-t-lg">
                      <div className="mx-auto w-full max-w-5xl">
                        <DrawerHeader className="pb-10 border-b border-border/20">
                          <div className="flex flex-col md:flex-row md:items-center gap-6">
                            <div className="flex items-center justify-center w-16 h-16 bg-primary text-primary-foreground font-mono text-2xl font-bold rounded-md shadow-lg shadow-primary/20">
                              {step.id}
                            </div>
                            <div className="text-left">
                              <DrawerTitle className="text-3xl md:text-4xl font-sans font-bold text-foreground uppercase italic tracking-tighter">
                                Protocollo {step.title}
                              </DrawerTitle>
                              <DrawerDescription className="text-lg text-muted-foreground mt-2 font-sans max-w-2xl">
                                {step.description}
                              </DrawerDescription>
                            </div>
                          </div>
                        </DrawerHeader>
                        
                        <div className="p-6 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-12">
                          {}
                          <div className="space-y-6">
                            <h4 className="text-xs font-mono text-primary uppercase tracking-[0.3em] flex items-center gap-3 border-b border-border/20 pb-4">
                              <Activity className="w-4 h-4" />
                              Operational_Log
                            </h4>
                            <ul className="space-y-4">
                              {stepSubSteps.map((subStep, j) => <li key={j} data-index={j} className="flex items-start gap-4 text-sm font-sans text-muted-foreground group/item">
                                  <ChevronRight className="w-4 h-4 text-primary shrink-0 mt-0.5 transition-transform group-hover/item:translate-x-1" />
                                  <span className="group-hover/item:text-foreground transition-colors">{subStep.text}</span>
                                </li>)}
                            </ul>
                          </div>

                          {}
                          <div className="space-y-6">
                            <h4 className="text-xs font-mono text-primary uppercase tracking-[0.3em] flex items-center gap-3 border-b border-border/20 pb-4">
                              <FileText className="w-4 h-4" />
                              System_Output
                            </h4>
                            <div className="grid gap-3">
                              {stepDeliverables.map((deliverable, k) => <div key={k} data-index={k} className="flex items-center gap-4 text-sm font-mono text-foreground bg-muted/20 p-4 border border-border/30 rounded-md hover:border-primary/30 transition-colors">
                                  <CircleCheck className="w-5 h-5 text-primary shrink-0" />
                                  <span>{deliverable.text}</span>
                                </div>)}
                            </div>
                          </div>
                        </div>

                        <DrawerFooter className="border-t border-border/20 pt-8 pb-12 sm:justify-between sm:flex-row items-center">
                          <div className="flex items-center gap-4">
                            <div className="w-2 h-2 rounded-lg bg-primary animate-pulse" />
                            <p className="text-[10px] font-mono text-muted-foreground tracking-widest uppercase">
                              Status: System_Ready 
                            </p>
                          </div>
                          <DrawerClose asChild>
                            <Button variant="outline" className="w-full sm:w-auto font-mono uppercase tracking-widest text-[10px] border-primary/20 hover:border-primary hover:bg-primary/5 hover:text-primary transition-all px-8 py-6 rounded-md">
                              Termina Sessione
                            </Button>
                          </DrawerClose>
                        </DrawerFooter>
                      </div>
                    </DrawerContent>
                  </Drawer></SafeHydrate>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}